import React, { useEffect } from "react";
import { Play } from "lucide-react"; // Play icon
import bingoImg from "../assets/balls-BDjg0rhe.png"; // ← place your image in /src/assets/
import Navbar2 from "../components/navbar/Navbar2";
import AOS from "aos";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";

export default function HomePage() {
  useEffect(() => {
    AOS.init({
      offset: 100,
      duration: 500,
      easing: "ease-in-sine",
      delay: 100,
    });
    AOS.refresh();
  }, []);

  const navigate = useNavigate();

  const handlePlay = () => {
    navigate("/betamountpage"); // Navigate to bitamount page
  };

  return (
    <>
      <div className="fixed left-0 right-0 top-0 z-50 bg-gradient-to-l from-violet-900 via-violet-800 to-violet-900 ">
        {/* <Navbar /> */}
        <Navbar2 />
      </div>
      <div className="min-h-screen bg-[#0b3557] flex flex-col justify-center items-center px-4 py-10 sm:py-16 pt-20">
        {/* Main Section */}
        <div className="flex flex-col-reverse lg:flex-row items-center justify-between w-full max-w-6xl gap-10 lg:gap-20">
          {/* Left Section: Bingo Card */}
          <div className="bg-gradient-to-r from-[#123f63] to-[#0b3557] shadow-2xl rounded-2xl p-8 sm:p-10 text-white w-full max-w-md">
            <div className="flex items-center mb-6">
              <div className="flex justify-center items-center w-16 md:w-14 h-14 rounded-full border-4 border-white text-2xl font-bold">
                8
              </div>
              <h1 className="ml-4 text-2xl sm:text-3xl font-semibold font-serif">
                Bingo Game{" "}
                <span className="text-gray-300 text-xl font-serif">
                  (ቢንጎ ጨዋታ)
                </span>
              </h1>
            </div>

            <p className="text-gray-200 text-lg sm:text-xl mb-8 font-serif">
              Join our live Bingo sessions and test your luck today.
            </p>

            <button
              className="flex items-center gap-2 bg-white text-[#0b3557] px-6 py-3 rounded-full font-semibold hover:bg-gray-100 transition-all"
              onClick={handlePlay}
            >
              <Play className="w-5 h-5 text-green-600 font-serif" />
              Play
            </button>
          </div>

          {/* Right Section: Bingo Image */}
          <div className="flex justify-center w-full lg:w-1/2">
            <img
              src={bingoImg}
              alt="Bingo Balls"
              className="w-64 sm:w-80 md:w-[420px] drop-shadow-2xl"
            />
          </div>
        </div>

        {/* Footer */}
        <div className="mt-12 text-center text-gray-300 text-sm font-serif">
          © {new Date().getFullYear()} ኢት ቢንጎ | Play Responsibly
        </div>
      </div>
    </>
  );
}
